import { APP_VERSION } from "@shared/index";

export default function AppVersion({ className = "" }: { className?: string }) {
  return <div className={`text-[11px] tabular-nums tracking-wide text-slate-500 ${className}`}>Version {APP_VERSION}</div>;
}
